import { useState } from "react"

import { useAppContext } from "providers/AppProvider/AppProvider"
import { useUI } from "providers/UIProvider"

import { Box, Flex, Image, Text, Spinner } from "@chakra-ui/react"
import Dropdown from "components/UI/atoms/Dropdown"
import Icon from "components/UI/atoms/Icon"
import useCompanyBranches from "hooks/useCompanyBranches"
import { IRoles } from "types/shared"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"

interface props {
  width?: string
}

const CompanyBranchesForReservations = ({ width = "306px" }: props) => {
  const { T } = useUI()
  const { branchesSearchValue, updateBranchesSearchValue, userRole } = useAppContext()
  const { selectedBranchForReservation, updateSelectedBranchForReservation } = useReservationsContext()
  const { singleLaundry, laundryBranchesDataLoading, branchOptions } = useCompanyBranches()
  const [dropdownOpened, toggleDropdown] = useState<boolean>(false)
  const handleSelectItem = (val: number) => {
    let updatedSelectedBranch = 0;
    if (selectedBranchForReservation === val) {
      updatedSelectedBranch = 0
    } else {
      updatedSelectedBranch = val
    }

    updateSelectedBranchForReservation(updatedSelectedBranch)

  }
  const selectedBranch = selectedBranchForReservation !== 0 && branchOptions.find((branchOption) => branchOption.id && selectedBranchForReservation === (branchOption.id)) || null
  const logoUrl = singleLaundry?.logoUrl || selectedBranch?.leftImg
  const title = singleLaundry?.name ? `${singleLaundry?.name} ${singleLaundry?.address}` : selectedBranch?.label
  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);
  return (
    <Box position="relative" width="306px" height="58px">
      {(
        <Box
          width={width}
          height="58px"
          as="button"
          backgroundColor="white"
          borderRadius="base"
          borderBottomRadius={dropdownOpened ? "0" : "base"}
          pointerEvents={dropdownOpened ? "none" : "auto"}
          boxShadow="primary"
          fontSize="base"
          fontFamily="heading"
          padding="0 15px"
          onClick={() => toggleDropdown(true)}
        >
          <Flex width="100%" height="100%" alignItems="center" justifyContent ="space-between">
            {isQappUser && selectedBranchForReservation !== 0 && <Image src={logoUrl} alt="Company" width="45px" />}
            {!isQappUser && <Image src={logoUrl} alt="Company" width="45px" />}
            { }
            <Text ml="20px" mr="20px">
              {isQappUser && (selectedBranchForReservation !== 0 ? title : T("general.select_branches"))}
              {!isQappUser && title}
            </Text>
            {isQappUser && laundryBranchesDataLoading && <Spinner />}
            {isQappUser && <Icon name="dropdown" iconStyles={{ fill: "#00000" }} />}
           
          </Flex>
        </Box>
      )}
      {isQappUser && (
        <Dropdown
          height="25rem"
          selectable
          handleSelectItem={handleSelectItem}
          searchable
          selected={selectedBranch?.id?.toString()}
          selectedItems={[selectedBranchForReservation]}
          searchValue={branchesSearchValue}
          onSearch={(val) => updateBranchesSearchValue(val)}
          searchPlaceholder={T("general.search_for_company")}
          opened={dropdownOpened}
          toggleOpened={toggleDropdown}
          items={branchOptions}
          styles={{
            top: "59px",
            fontWeight: "bold",
          }}
        />
      )}
    </Box>
  )
}

export default CompanyBranchesForReservations
